import { gql } from '@apollo/client';

export const QUERY_EYE_COLOR = gql`
  query eyeColors {
    eyeColors {
      id
      name
    }
  }
`;
